export type IActiveToolCall = {
  callId: string;
  toolName: string;
  label: string;
  startedAt: number;
};

export type IAssistantMessageAttachment = {
  id: string;
  name: string;
  mime?: string;
  previewUrl?: string;
};

export type IAssistantMessage = {
  id: string;
  content: string;
  role: string;
  chunk?: boolean;
  thinking?: boolean;
  stream?: boolean;
  toolCall?: IActiveToolCall;
  attachments?: Array<IAssistantMessageAttachment>;
};

export type IAssistantMessageChunk = {
  id: string;
  content: string;
  index: number;
};

export enum EAssistantEvent {
  INCOMING_MESSAGE = "INCOMING_MESSAGE",
  INCOMING_MESSAGE_CHUNK = "INCOMING_MESSAGE_CHUNK",
  OUTGOING_MESSAGE = "OUTGOING_MESSAGE",
}

export type AssistantEventMap = {
  [EAssistantEvent.INCOMING_MESSAGE]: {
    eventType: EAssistantEvent.INCOMING_MESSAGE;
  };
  [EAssistantEvent.INCOMING_MESSAGE_CHUNK]: {
    eventType: EAssistantEvent.INCOMING_MESSAGE_CHUNK;
  };
  [EAssistantEvent.OUTGOING_MESSAGE]: {
    eventType: EAssistantEvent.OUTGOING_MESSAGE;
  };
};

export type IAssistantEvent = AssistantEventMap[keyof AssistantEventMap];
